import { gql } from '@apollo/client';
import GraphQL from '../graphQL';
import store from '@store/store';

const MARK_SKILL_AS_SUPERPOWER = gql`
    mutation MarkSkillAsSuperPower($skillId: Int!, $isSuperPower: Boolean!) {
        markSkillAsSuperPower(skillId: $skillId, isSuperPower: $isSuperPower)
    }
`;

export default async function markSkillAsSuperPower(skillId: number, isSuperPower: boolean): Promise<boolean> {
    const result = await GraphQL.mutate<boolean>(MARK_SKILL_AS_SUPERPOWER, { skillId, isSuperPower });
    
    // Refetch employee to update UI
    const getEmployee = (await import('./getEmployee')).default;
    await getEmployee(store.getState().employee.id);
    
    return result;
}
